export default function PhoneMockup({
  src,
  alt = "SAFE — Interface de l'application",
  className = "",
}) {
  return (
    <div className={`phone-mockup ${className}`}>
      <div className="phone-mockup-glow" aria-hidden="true" />
      <div className="phone-mockup-device">
        <div className="phone-mockup-bezel">
          <div className="phone-mockup-speaker" aria-hidden="true" />
          <div className="phone-mockup-screen">
            <img
              src={src}
              alt={alt}
              className="phone-mockup-image"
              loading="eager"
              decoding="async"
            />
          </div>
          <div className="phone-mockup-home-bar" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
